import React from 'react';

import CmLoader from '../primitives/CmLoader';
import styles from './EmptyState.module.css';

export interface LoadingStateProps {
  message?: React.ReactNode;
  testId?: string;
}

export function LoadingState({ message, testId }: LoadingStateProps): React.ReactElement {
  return (
    <div className={styles.loading} data-testid={testId}>
      <CmLoader />
      {message ? <div className={styles.message}>{message}</div> : null}
    </div>
  );
}

export default LoadingState;
